// ============================================================
// CareChargeRoleMappingsSection.jsx  (role-model expansion Push 1; refactored
// onto the shared ModuleRoleMappingsSection 2026-07-13)
//
// Thin instantiation of the shared component — no tier (single access level).
// Finance / Finance Manager.
// ============================================================

import React from 'react';
import ModuleRoleMappingsSection from './ModuleRoleMappingsSection';
import {
  listCareChargeRoleMappings,
  createCareChargeRoleMapping,
  deleteCareChargeRoleMapping,
} from '../api/federation';

const ROLE_LABEL = { finance: 'Finance', finance_manager: 'Finance Manager' };

export default function CareChargeRoleMappingsSection({ clientId }) {
  return (
    <ModuleRoleMappingsSection
      clientId={clientId}
      testId="carecharge-role-mappings"
      title="CareCharge role mappings"
      descriptor="Map an AD group to a CareCharge module role (Finance / Finance Manager). Members are auto-granted on sign-in and the hourly reconcile; Finance Manager also carries CareCharge settings write."
      roleField="careChargeRole"
      roleOptions={[{ value: 'finance', label: 'Finance' }, { value: 'finance_manager', label: 'Finance Manager' }]}
      emptyMessage="No CareCharge role mappings configured yet."
      confirmTitle="Remove CareCharge role mapping?"
      confirmMessage={(t) => `Members of "${t.groupDisplayName || t.groupObjectId}" will lose this ${ROLE_LABEL[t.careChargeRole] || t.careChargeRole} mapping at the next reconcile. Existing grants are not removed immediately.`}
      toastCreated="CareCharge role mapping created."
      toastRemoved="CareCharge role mapping removed."
      api={{ list: listCareChargeRoleMappings, create: createCareChargeRoleMapping, remove: deleteCareChargeRoleMapping }}
    />
  );
}
